import events from '@/services/events';
import Clipboard from 'clipboard';

const copyToClipboard = {
  beforeMount(element, binding) {
    const options = binding.value || {};

    element.setAttribute('data-clipboard-text', options.value);

    const clipboard = new Clipboard(element);

    clipboard.on('error', () => {
      events.emit('notification', {
        type: 'error',
        message: 'Failed to copy to clipboard.'
      });
    });

    clipboard.on('success', () => {
      events.emit('notification', {
        type: 'success',
        message: options.successMessage ? options.successMessage : 'Copied to clipboard!'
      });
    });
  }
};



export default copyToClipboard;
